import React, { useState } from 'react'
import {Modal, Spinner }from 'react-bootstrap';
import ModalWrapper from './ModalWrapper';
import { useGlobalModalContext } from '../../context/GlobalModals';
import {delay} from '../../tools/delay'
import http from '../../api/http';
import { sparepartAPI } from '../../api/sparepart';
import {Sparepart} from '../../api/sparepart/types'
import { useNavigate } from "react-router-dom";
import { PageAnimate } from '../../components/PageAnimate'


interface showData {
    showGlobal: boolean
    afterSubmit: Function
} 

export default function InsertSparepartModal({showGlobal=false, afterSubmit}:showData) {
    const [show, setShow] = useState(showGlobal);

    const { hideModal } = useGlobalModalContext()

    const handleClose = async () => {
        setShow(false);
        await delay(500);
        hideModal();
    }

    function callDelete() {
        // return http.post(url,{id: id})
        return delay(1000);
    }

    const showModal = () => {
        setShow(true);
    }

    const [namaSparepart, setketerangan] = useState("");
    const [kodeSparepart, setkode] = useState("");
    const [noPart, setnumberApart] = useState(0);
    const [hargaBaru, sethargaBaru] = useState(0);

    const navigate = useNavigate();

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setIsSubmitting(true);

        const jsonInput:Sparepart = {
            namaSparepart: namaSparepart,
            kodeSparepart: kodeSparepart,
            hargaBaru: hargaBaru,
            noPart: noPart,
        };

        const addSparepart = await sparepartAPI.createSparepart(jsonInput);
        setIsSubmitting(false);
        afterSubmit();
        handleClose();


    }

    const [isSubmitting, setIsSubmitting] = useState(false);

    async function submitDelete(){
        try {
            setIsSubmitting(true);
            await callDelete();
            setIsSubmitting(false);
            handleClose();
        } catch (e) {
            setIsSubmitting(false);
        }
        
    }



    return (
        <>
        <ModalWrapper>
            <Modal title={'INSERT DATA'}
            show={show}
            onHide={handleClose}
            backdrop="static"
            centered
            size="lg"
            keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>TAMBAH SPAREPART</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <form className="form mb-15" id="kt_careers_form">
                            {/* <!--begin::Input group--> */}
                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 col-6">
                                
                                {/* <!--begin::Table body--> */}
                                <tbody>
                                    <tr>
                                        <td>
                                            <a href="#" className="text-dark fw-bolder text-hover-primary fs-6">KETERANGAN :</a>
                                        </td>
                                        <td className="text-dark fw-bolder text-hover-primary fs-6" colSpan={2}>
                                            <input type="text" className="form-control form-control-solid" placeholder="Isi Nama Sparepart" onChange={(e) => setketerangan(e.target.value)} value={namaSparepart} required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a href="#" className="text-dark fw-bolder text-hover-primary fs-6">KODE :</a>
                                        </td>
                                        <td className="text-dark fw-bolder text-hover-primary fs-6" colSpan={2}>
                                        <input type="text" className="form-control form-control-solid" placeholder="Isi Kode Sparepart" onChange={(e) => setkode(e.target.value)} value={kodeSparepart} required/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a href="#" className="text-dark fw-bolder text-hover-primary fs-6">NUMBER PART :</a>
                                        </td>
                                        <td className="text-dark fw-bolder text-hover-primary fs-6" colSpan={2}>
                                            <input type="text" className="form-control form-control-solid" placeholder="Nomor Part" onChange={(e) => setnumberApart(parseInt(e.target.value))} value={noPart} required/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a href="#" className="text-dark fw-bolder text-hover-primary fs-6">HARGA BARU :</a>
                                        </td>
                                        <td className="text-dark fw-bolder text-hover-primary fs-6" colSpan={2}>
                                            <input type="text" className="form-control form-control-solid" placeholder="Isi Harga Baru" onChange={(e) => sethargaBaru(parseInt(e.target.value))} value={hargaBaru}required/>
                                        </td>
                                    </tr>
                                    
                                </tbody>
                                {/* <!--end::Table body--> */}
                            </table>
                </form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={handleClose}>Batal</button>
                    <button type="button" className="btn btn-primary" disabled={namaSparepart === '' || kodeSparepart ==='' || isSubmitting} onClick={handleSubmit}>{isSubmitting? <Spinner animation="border" style={{
                // marginLeft:"50vw",
                // display:"flex",
                // flex: 1,
                // marginTop:"50vh",
                justifyContent: 'center',
                alignItems:'center'}} /> : 'SIMPAN'}</button>
                </Modal.Footer>
            </Modal>
        </ModalWrapper>
        </>
    )
                    }
